import {
  SwipeableDrawer,
  Collapse,
  Avatar,
  DialogTitle,
  DialogContent,
  DialogActions,
  Dialog,
  TextField,
  makeStyles,
  FormControl,
  MenuItem,
  Select,
  CircularProgress,
  Divider,
  IconButton,
  Card,
  CardActionArea,
  Chip,
  CardMedia,
  CardContent,
  Popover,
  Modal,
  Breadcrumbs,
  Button,
  Link,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Backdrop,
} from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';

export default {
  SwipeableDrawer,
  Collapse,
  Accordion,
  Backdrop,
  AccordionDetails,
  Autocomplete,
  AccordionSummary,
  Avatar,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  makeStyles,
  FormControl,
  MenuItem,
  Select,
  CircularProgress,
  Dialog,
  IconButton,
  Divider,
  CardActionArea,
  Chip,
  Card,
  CardMedia,
  CardContent,
  Popover,
  Modal,
  Breadcrumbs,
  Link,
  Button,
};
